import { cn } from '@zep/utils';

import { ProductTheme } from './types';

const COLORS = {
  WHITE: '#FFFFFF',
} as const;

const RESPONSIVE_CLASS_NAME = cn(
  'h-[36px] tablet:h-[40px] lg:h-[48px]',
  'px-[12px] lg:px-[16px]',
  'text-quiz-caption-lg-semibold tablet:text-quiz-body-sm-semibold lg:text-quiz-body-lg-semibold',
  '[&>svg]:size-[16px] tablet:[&>svg]:size-[20px] lg:[&>svg]:size-[24px]',
);

const PRIMARY_CLASS_NAME = cn(
  RESPONSIVE_CLASS_NAME,
  'bg-[var(--bg)] hover:bg-[var(--hover-bg)] disabled:bg-opacity-30',
);

const SECONDARY_CLASS_NAME = cn(
  RESPONSIVE_CLASS_NAME,
  'hover:bg-[var(--hover-bg)] hover:border-[var(--hover-border)] hover:text-[var(--hover-color)]',
);

export const useProductButtonStyles = (theme: ProductTheme) => {
  const primaryStyle = {
    '--bg': theme.primaryColor,
    '--hover-bg': theme.primaryHoverColor || theme.primaryColor,
    color: COLORS.WHITE,
  };

  const secondaryStyle = {
    color: theme.primaryColor,
    borderColor: theme.primaryColor,
    '--hover-bg': theme.secondaryHoverBg || 'transparent',
    '--hover-border': theme.secondaryHoverBorder || theme.primaryColor,
    '--hover-color': theme.secondaryHoverColor || theme.primaryColor,
  };

  return {
    primaryStyle,
    primaryClassName: PRIMARY_CLASS_NAME,
    secondaryStyle,
    secondaryClassName: SECONDARY_CLASS_NAME,
  };
};
